import { FLink } from '@components';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';

export const ParcelaAtraso = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="card">
      <div className="card-body">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-3">
          Parcelas em atraso do contrato: {id}
        </h3>
        <p>
          A regularização de valores em atraso é realizada por meio do link
          abaixo onde será possível a emissão de boleto para pagamento a vista
          ou negociação para pagamento de forma parcelada. Em caso de dúvida,
          entre em contato com nosso 0800 090 9090 ou via whatsapp (31)
          99897-4872.
        </p>
        <p className="mt-3">
          PORTAL DE NEGOCIAÇÃO:{' '}
          <a
            className="link d-inline fs-6 text-orange"
            target="_blank"
            href="https://negociacomigo.org.br/"
            rel="noreferrer"
          >
            negociacomigo.org.br
          </a>
        </p>
      </div>
    </div>
  );
};
